import $ from 'jquery';
import 'jquery.mmenu/dist/jquery.mmenu.all'; // TODO Use custom build instead of full script
import { checkScrollBar, getScrollbar, parseTemplate } from '../common/helpers';
import Reason from './Reason';
import AttachPhotos from './AttachPhotos';

class Popup {
  constructor($element, reasons, commentMaxLength) {
    this.$el = $element;
    this.reasons = reasons;
    this.commentMaxLength = commentMaxLength;

    this.isDesktop = $(window).width() >= 576;

    this.panelTemplate = $('#reason-popup__panel-template').html();

    this.initMmenu();

    window.matchMedia('(min-width: 576px)').addEventListener('change', (mq) => {
      this.isDesktop = mq.matches;

      // TODO optimize - do not remove/add menu after each toggling media query
      if (this.$mmenu.hasClass('mm-menu_opened')) {
        this.api.bind('close:finish', () => {
          this.$mmenu.remove();
          this.initMmenu();
        });

        this.api.close();
      } else {
        this.$mmenu.remove();
        this.initMmenu();
      }
    });
  }

  initMmenu() {
    const self = this;

    const $body = $('body');
    const scrollbarWidth = getScrollbar();

    this.$mmenu = this.$el.mmenu({
      extensions: [
        'pagedim-black',
        this.isDesktop ? 'popup' : 'position-bottom',
        'fx-panels-slide-up', // 'fx-panels-none'
      ],

      hooks: {
        'initMenu:after': function initMenuHook() {
          this.$menu.height(305);
        },

        'open:before': () => {
          if (checkScrollBar()) {
            $body.css('padding-right', scrollbarWidth);
          }
        },

        'close:finish': function closeFinishHook() {
          this.closeAllPanels();
          self.clearPopup();
          this.$menu.height(305);

          $body.css('padding-right', '');
        },
      },

      navbar: false,

      autoHeight: true,
    }, {
      clone: true,
    });

    this.api = this.$mmenu.data('mmenu');
    this.$quantityForm = this.$mmenu.find('.reason-popup__form_quantity');
    this.$quantity = this.$quantityForm.find('.js-quantity');
    this.$panels = $();

    const $attachPhotos = this.$quantityForm.find('.attach-photos');
    this.attachPhotos = $attachPhotos.length ? new AttachPhotos($attachPhotos, {
      onResize: () => self.resizeMmenu(),
      onRemove: (photoId) => {
        if (self.batch) {
          self.product.removeBatchPhoto(self.batch.id, photoId);
        }
      },
    }) : null;

    this.handleBack();
    this.handleQuantityPanel();
  }

  clearPopup() {
    // Remove panels with reasons
    this.$panels.remove();
    this.$panels = $();
    this.batch = null;
  }

  handleBack() {
    const self = this;

    this.$mmenu.on(`click${Popup.NAMESPACE}`, '.reason-popup__back', function backClick(event) {
      event.preventDefault();
      const $prevPanel = $(this).closest(Popup.PANEL).prev(Popup.PANEL);

      if ($prevPanel.length) {
        // Open previous panel if current is not the first
        self.api.openPanel($prevPanel);
      } else {
        // Close menu if current in the first
        self.api.close();
      }
    });
  }

  /**
   * @param {import('./SelectionProduct').default} product
   * @param {{ id: number, quantity: number, reason: object }} [batch] batch being edited, if any
   */
  open(product, batch = null) {
    this.product = product;
    this.batch = batch;

    if (this.attachPhotos) {
      const index = product.getBatchStartIndex(batch ? batch.id : undefined);
      this.attachPhotos.reset(product.id, index, (batch && batch.photos[0]) || []);
    } else {
      const ownQuantity = batch ? batch.quantity : 0;

      // Fill the quantity dropdown with the amount still available, plus whatever
      // this batch already holds (so editing it down/up stays within bounds)
      this.fillQuantity(this.product.remaining() + ownQuantity, ownQuantity);
    }

    this.addPanels(batch ? [batch.reason] : []);
    this.api.open();
  }

  fillQuantity(available, current) {
    let $options = $();

    for (let i = 0; i <= available; i += 1) {
      // If quantity is not specified - select the maximal value
      const isSelected = current === 0 ? i === available : i === current;
      $options = $options.add(`<option value="${i}" ${isSelected ? 'selected' : ''}>${i}</option>`);
    }

    this.$quantity.empty().append($options);
  }

  handleQuantityPanel() {
    this.$quantityForm.on(`submit${Popup.NAMESPACE}`, (event) => {
      event.preventDefault();

      if (this.attachPhotos && this.attachPhotos.isUploading()) {
        this.attachPhotos.showUploadingMessage();
        return;
      }

      if (this.attachPhotos && !this.attachPhotos.isSatisfied()) {
        this.attachPhotos.showRequiredMessage();
        return;
      }

      if (this.attachPhotos && this.attachPhotos.isOverMaximum()) {
        this.attachPhotos.showMaximumError();
        return;
      }

      const quantity = Number.parseInt(this.$quantity.val(), 10);

      if (quantity === 0) {
        // Zero quantity: drop the batch being edited, or just close if adding a new one
        if (this.batch) {
          this.product.removeBatch(this.batch.id);
        }
        this.api.close();
        return;
      }

      if (quantity > this.$panels.length) {
        // Need to add panels to popup
        this.addPanels();
      } else if (quantity < this.$panels.length) {
        // Need to remove panels from popup
        this.removePanels(quantity);
      }

      // Open first panel
      this.api.openPanel(this.$panels.first());
    });
  }

  createPanel(index) {
    return $(parseTemplate(this.panelTemplate, {
      index,
      counter: index + 1,
    }));
  }

  addPanels(initial = []) {
    const self = this;

    if (!this.$panels.length) {
      const i = 0;
      const $panel = this.createPanel(i);
      this.api.initPanels($panel);
      this.$panels = this.$panels.add($panel);

      const $reasons = $panel.find('.reasons');
      if (typeof initial[i] !== 'undefined') {
        $reasons.data('reasons', initial[i]);
      }
      $reasons.data('reason', new Reason($reasons, {
        name: 'reasons',
        index: i,
        reasons: this.reasons,
        commentMaxLength: this.commentMaxLength,
        additionalClass: 'input_size_sm',
        callbacks: {
          action() {
            // "this" refers to "Action" select
            $panel.find('.js-exchange-warning').toggleClass('hidden', $(this).val() !== 'Exchange');
          },
        },
      }));
      $reasons.on('change', 'select', () => {
        self.resizeMmenu();
      });

      $panel.find('form').validate({
        invalidHandler() {
          // handler is fired before the error message shown, so we need the delay before resize
          setTimeout(() => {
            self.resizeMmenu();
          }, 1);
        },
        submitHandler(form) {
          const $nextPanel = $(form).closest(Popup.PANEL).next(Popup.PANEL);

          if ($nextPanel.length) {
            self.api.openPanel($nextPanel);
          } else {
            const quantity = Number.parseInt(self.$quantity.val(), 10);
            const reason = self.$mmenu.find('.reasons').data('reason').getValue();
            const photoIds = self.attachPhotos ? self.attachPhotos.getPhotoIds() : [];

            if (self.batch) {
              self.product.updateBatch(self.batch.id, quantity, reason, photoIds);
            } else {
              self.product.addBatch(quantity, reason, photoIds);
            }

            self.api.close();
          }
        },
      });
    }
  }

  removePanels(quantity) {
    const $removing = this.$panels.slice(quantity);
    $removing.remove();
    this.$panels = this.$panels.not($removing);
  }

  resizeMmenu() {
    // TODO optimize
    // height transition enabled by default, so adding new dropdowns triggers ugly animation
    // so we remove transition, add dropdown, change height and add transition again
    this.$mmenu.removeClass('mm-menu_autoheight');
    this.api.getInstance().trigger('updateListview'); // autoheight plugin binded to this event
    setTimeout(() => {
      this.$mmenu.addClass('mm-menu_autoheight');
    }, 1);
  }
}

Popup.NAMESPACE = '.popup';
Popup.PANEL = '.mm-panel';

export default Popup;
